// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"130":"f34e8777","999":"0aad781f"}[chunkId] + ".chunk.js";
};